<template>
    <div class="About">
        <layout>
            <template slot="content">
                <img src="@/assets/images/about/banner.png" class="contentImg"/>
                <img src="@/assets/images/about/content1.jpg" class="contentImg"/>
                <img src="@/assets/images/about/content2.jpg" class="contentImg"/>
                <img src="@/assets/images/about/content3.jpg" class="contentImg"/>
            </template>
        </layout>
    </div>
</template>

<script>
import Layout from '@/components/Layout/index.vue'
export default {
    name:'About',
    components: {
        Layout
    },
    props:{},
    data() {
        return {

        };
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {},
    methods: {},
}
</script>
<style scoped>
.contentImg{
    width: 100%;
    float: left;
}
</style>